import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Loading from '../../components/Loading/Loading';

const SwitchRoutes = ({ routes, redirect }) => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {routes.map(({ path, Component }) => {
          return <Route key={path} path={path} element={<Component />} />;
        })}
        <Route path='*' element={<Navigate replace to={redirect} />} />
      </Routes>
    </Suspense>
  );
};

export default SwitchRoutes;
